/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import PlatformMsisdnPoolNumber from '../../../interfaces/platform/PlatformMsisdnPoolNumber';
import GridContainer from '../../../components/Grid/GridContainer';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { SimCardCollectionInterface } from '../../../interfaces/collections/SimCardCollectionInterface';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import GridItem from '../../../components/Grid/GridItem';
import TableHead from '@material-ui/core/TableHead';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import TableCell from '@material-ui/core/TableCell';
import { makeStyles, TableBody, Typography } from '@material-ui/core';
import PaperedTable from '../../../components/Table/PaperedTable';
import I18n from '../../../components/Translate/I18n';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import TableRow from '@material-ui/core/TableRow';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import { history } from '../../../core/history';
import ViewButton from '../../../components/Buttons/ViewButton';
import { useDispatch } from 'react-redux';
import SettingsButton from '../../../components/Buttons/SettingsButton';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CardBody from '../../../components/Card/CardBody';
import Card from '../../../components/Card/Card';
import OplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';

type MsisdnHistoryType = {
    classes: any;
    msisdn: PlatformMsisdnPoolNumber;
};

const MsisdnImsiHistory: FunctionComponent<MsisdnHistoryType> = ({ classes, msisdn }): React.ReactElement => {
    const [simCards, setSimCards] = useState<SimCardCollectionInterface | null>(null);
    const dispatch = useDispatch();
    useEffect(() => {
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_cards')),
            'msisdn_history_storage_view_get',
            [{ name: 'msisdnAll', value: msisdn.msisdn }],
            [
                { name: 'deleted', value: 'asc' },
                { name: 'id', value: 'desc' },
            ],
            (data: SimCardCollectionInterface) => {
                setSimCards(data);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }, [dispatch, msisdn]);

    const goToImsiStorage = (item: { uri: string }): void => {
        history.push(FormGeneralHelper.getRouteUrl('/iccid-view' + item.uri));
    };

    const goToProduct = (item: { uri: string }): void => {
        history.push(FormGeneralHelper.getRouteUrl('/sim-card-edit' + item.uri));
    };

    const tableRowRoot = { root: classes.tableRowRoot };
    const tableCellRoot = { root: classes.tableCellRootBordered };

    return (
        <Card>
            <CardHeader trans="pools:pool.parring_history" />
            <CardBody>
                <PaperedTable>
                    <TableHead>
                        <TableRow>
                            <TableCell padding="none" align="left">
                                <TableHeaderContentCell textAlign="left" title="general:common.commands" fieldName="imsi" onlyFilter={true} />
                            </TableCell>
                            <TableCell padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="pools:pool.imsi"
                                    fieldName="imsi"
                                    showSort={false}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                />
                            </TableCell>
                            <TableCell padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="pools:pool.iccid"
                                    fieldName="iccid"
                                    showSort={false}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                />
                            </TableCell>
                            <TableCell padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="pools:pool.change_date"
                                    fieldName="parentProductDate"
                                    showSort={false}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {simCards &&
                            simCards['hydra:member'] &&
                            simCards['hydra:member'].map((simCard: SimCardInterface) => {
                                return (
                                    <TableRow key={'sim_card_asd_' + simCard.id} classes={tableRowRoot}>
                                        <TableCell classes={tableCellRoot} padding="none" align="left" style={{ paddingLeft: 0 }}>
                                            {simCard.platformIccidPoolNumber && (
                                                <ViewButton
                                                    tooltipTitle="pools:sim.imsi_view"
                                                    callback={goToImsiStorage}
                                                    callbackParam={{ uri: simCard.platformIccidPoolNumber }}
                                                />
                                            )}
                                            <SettingsButton
                                                callback={goToProduct}
                                                callbackParam={{ uri: simCard['@id'] }}
                                                tooltipTitle="pools:msisdn.produkt_view"
                                            />
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            {simCard.imsi}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            {simCard.iccid}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            {!simCard.active && simCard.deleted && simCard.deletedDate && (
                                                <I18n
                                                    trans="pools:msisdn.activation_canceled"
                                                    valueObject={{ date: DateHelperTs.format(simCard.deletedDate) }}
                                                />
                                            )}
                                            {simCard.active && simCard.parentProductDate && !simCard.msisdn.includes('change_msisdn') && (
                                                <I18n
                                                    trans="pools:msisdn.change_imsi"
                                                    valueObject={{ date: DateHelperTs.format(simCard.parentProductDate) }}
                                                />
                                            )}
                                            {simCard.active && simCard.parentProductDate && simCard.msisdn.includes('change_msisdn') && (
                                                <I18n
                                                    trans="pools:msisdn.change_msisdn"
                                                    valueObject={{date: DateHelperTs.format(simCard.parentProductDate)}}
                                                />
                                            )}
                                            {simCard.active && !simCard.parentProductDate && simCard.deletedDate && (
                                                <I18n
                                                    trans="pools:msisdn.product_deleted"
                                                    valueObject={{ date: DateHelperTs.format(simCard.deletedDate) }}
                                                />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </PaperedTable>
            </CardBody>
        </Card>
    );
};

export default withStyles(OplAppStyle)(MsisdnImsiHistory);
